import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { supabase } from '../lib/supabase';
import { useMyRestaurants } from '../hooks/useMyRestaurants';

interface Rec { title: string; detail: string }

export function ConsultantPage() {
  const { t } = useTranslation();
  const { restaurants, loading } = useMyRestaurants();
  const restaurant = restaurants[0];
  const [recs, setRecs] = useState<Rec[]>([]);
  const [updatedAt, setUpdatedAt] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (!restaurant) return;
    const { data } = await supabase
      .from('ai_recommendations')
      .select('recommendations, created_at')
      .eq('restaurant_id', restaurant.id)
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle();
    if (data) {
      setRecs((data.recommendations as Rec[]) ?? []);
      setUpdatedAt(data.created_at as string);
    }
  }, [restaurant]);

  useEffect(() => { void load(); }, [load]);

  async function generate() {
    if (!restaurant) return;
    setBusy(true);
    const { data, error } = await supabase.functions.invoke('ai-consultant', {
      body: { restaurant_id: restaurant.id }
    });
    setBusy(false);
    if (!error && data) {
      setRecs((data as { recommendations: Rec[] }).recommendations ?? []);
      void load();
    }
  }

  if (loading || !restaurant) return <div className="center-note">{t('common.loading')}</div>;

  return (
    <div className="page">
      <div className="page__head-row">
        <h1 className="page__title">{t('consultant.title')}</h1>
        <span className="badge">{t('consultant.premium')}</span>
      </div>

      <button type="button" className="btn btn--primary" onClick={() => void generate()} disabled={busy}>
        {busy ? t('consultant.generating') : t('consultant.generate')}
      </button>
      {updatedAt && <p className="muted-note">{t('consultant.updated')}: {new Date(updatedAt).toLocaleString()}</p>}

      {recs.length === 0 ? (
        <p className="muted-note">{t('consultant.none')}</p>
      ) : (
        <div style={{ marginTop: 16 }}>
          {recs.map((r, i) => (
            <div key={i} className="order-card" style={{ marginBottom: 12 }}>
              <strong>{i + 1}. {r.title}</strong>
              <p style={{ margin: '8px 0 0' }}>{r.detail}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
